import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import styles from './index.module.scss';
import { setFormData as setStandardFormData } from '../../WarrantyStandardForm/redux/actions';
import { setFormData as setTransferFormData } from '../../WarrantyTransferForm/redux/actions';

export const NO_SELECTION = false;

export const SelectOption = ({ value, text }) => {
  if (!text) text = _.capitalize(value);

  return <option value={value}>{text}</option>;
};

const mapStateToProps = state => ({
  formData: state.formData,
});

const Select = ({
  options,
  htmlAttributes,
  invalidInput,
  fieldKey,
  setStandardFormData,
  setTransferFormData,
  formData,
}) => {
  const { placeholder, className, disabled, ...otherHtmlAttributes } = htmlAttributes;
  const hasBlankOption = _.some(options, option => !option.props.value);
  const value = formData[fieldKey];

  function handleChange(event) {
    if (formData.formName == 'WarrantyStandard') {
      setStandardFormData({ [fieldKey]: event.target.value });
    } else {
      setTransferFormData({ [fieldKey]: event.target.value });
    }
  }

  return (
    <div className={className}>
      <div className={invalidInput ? styles.selectError : styles.select} disabled={disabled}>
        <select
          value={value}
          className={invalidInput ? styles.selectError : styles.select}
          id={otherHtmlAttributes.id || placeholder}
          required
          disabled={disabled}
          onChange={event => handleChange(event)}
          {...otherHtmlAttributes}
        >
          {!hasBlankOption && (
            <option key={NO_SELECTION} disabled value={NO_SELECTION}>
              {' '}
            </option>
          )}
          {options}
        </select>
        {placeholder && <label htmlFor={placeholder}>{placeholder}</label>}
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  setStandardFormData: hash => dispatch(setStandardFormData(hash)),
  setTransferFormData: hash => dispatch(setTransferFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Select);
